<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head back="Convention.Schedule.Rooms.Edit" :backParams="$route.meta.backParams" title="Spaces" subtitle="Manage the spaces that can be booked within this room" :readonly="$authorised('con/schedule/access', 'read')">

		<app-content-head-actions-item text="Create" icon="create" v-on:click="onCreateClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body v-if="is.initialised" :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no spaces found.">

		<app-table>

			<app-table-head :no-gap="true" :layout="layout">

				<app-table-column text="Name" />
				
				<app-table-column border="left" v-for="day in references.days" :key="day.value" :text="day.text" />

			</app-table-head>

			<app-table-body>

				<app-table-row :no-gap="true" v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.name" :subtext="seatCount(item)" />
				
					<app-table-cell-schedule border="left" v-for="day in references.days" :key="day.value" :space="item.id" :day="day.value" :scheduled="references.scheduled" :start="references.room.schedule.start" :end="references.room.schedule.end" :times="references.times" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				days: [],
				times: [],
				room: {},
				scheduled: []
			},
			endpoint: 'convention/schedule/rooms/:room/spaces',
			live: 'convention/schedule/rooms/:room/spaces'
		}

	},

	computed: {

		layout: function() {
		
			var layout = ['160px']

			this.$_.each(this.references.days, function() {
			
				layout.push('1fr')
			
			})

			return layout.join(' ')

		}
	
	},

	methods: {
	
		seatCount: function(item) {
		
			return (item.seats === 0) ? 'Unlimited' : item.seats.toString() + ' seat' + ((item.seats > 1) ? 's' : '')

		}
	
	}

}

</script>

<style scoped>

</style>